import React from "react";
import { connect } from "react-redux";

import DashboardAdd from "../../Components/Layouts/DashboardAdd";
import CategoryForm from "../../Components/Forms/CategoryForm";
import { createEntity, updateEntityInfo, setUpdatedRecentlyToFalse } from "../../Redux/CategoryForm/actions";
import { getEntityById } from "../../Redux/Category/actions";

function Add({ useAuth, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm }) {
  console.log(selectedForm);
  return (
    <DashboardAdd useAuth={useAuth}>
        <CategoryForm
          isAddForm
          {...{getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}}
        />
    </DashboardAdd>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.category,
    loginData: state.loginData,
    selectedForm: state.categoryForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEntityById:  (tokenData, id) =>  dispatch(getEntityById(tokenData, id)),
    createEntity: (formData, tokenData, exitAfter, history) => dispatch(createEntity(formData, tokenData, exitAfter, history)),
    updateEntityInfo: (formData, tokenData, id) => dispatch(updateEntityInfo(formData, tokenData, id)),
    setUpdatedRecentlyToFalse: () => dispatch(setUpdatedRecentlyToFalse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Add);
